import { render, staticRenderFns } from "./ImageNotesFile.vue?vue&type=template&id=1f14685a&"
import script from "./ImageNotesFile.vue?vue&type=script&lang=ts&"
export * from "./ImageNotesFile.vue?vue&type=script&lang=ts&"
import style0 from "./ImageNotesFile.vue?vue&type=style&index=0&id=1f14685a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports